import { Position } from "@xyflow/react";
import { NODE_REGISTRY } from "components/CC/Nodes/node-config";
import { BaseNodeProps } from "components/CC/Nodes/node-types";
import { BaseNode } from "components/CC/Nodes/NodeBase/BaseNode";
import { EndIcon, FailedOutcomeBadge, SuccessOutcomeBadge } from "components/CC/Nodes/NodeIcons";
import { NodeType, StepOutcome } from "components/CC/types/enums";
import { TransparentHandle } from "components/CC/UI/TransparentHandle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { ReactNode } from "react";

const OUTCOME_BADGE_MAP: Partial<Record<StepOutcome, ReactNode>> = {
    [StepOutcome.Success]: <SuccessOutcomeBadge />,
    [StepOutcome.Failed]: <FailedOutcomeBadge />,
};

export const EndNode = ({ id, data }: BaseNodeProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const formData = data?.formData as { success?: StepOutcome } | undefined;
    const badge = formData?.success ? OUTCOME_BADGE_MAP[formData.success] : undefined;

    return (
        <div>
            <BaseNode
                id={id}
                data={data}
                color={NODE_REGISTRY[NodeType.End].color}
                label={t("nodes.end.title")}
                badge={badge}
            >
                <EndIcon />
            </BaseNode>
            <TransparentHandle position={Position.Left} type="target" />
        </div>
    );
};
